import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Header from 'components/Header';
import Container from 'components/Container';
import Footer from 'components/Footer';
import Heading from 'components/Heading';
import SignUpForm from 'components/SignUpForm';
import TopBanner from 'components/TopBanner';
import { Helmet } from 'react-helmet';
import banner from './ecosystem.svg';

const Wrapper = styled.div`
  background: #ffffff;
  padding: 3em 0 4em 0;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  min-height: 300px;
`;

class MailingPage extends PureComponent {
  render() {
    return (
      <div>
        <Helmet>
          <title>Newsletter</title>
          <meta
            name="description"
            content="Subscribe to skycoin newsletter"
          />
        </Helmet>
        <Header />
        <TopBanner src={banner} />
        <Wrapper>
          <Container>
            <Heading>Subscribe to our mailing list</Heading>
            <SignUpForm reverted />
          </Container>
        </Wrapper>
        <Footer />
      </div>
    );
  }
}

export default MailingPage;



// WEBPACK FOOTER //
// ./src/components/MailingPage/MailingPage.js